module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ch1"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("“The Pleasant Early Years”")])])]), _vm._v(" "), _c('p', {
    staticClass: "DL"
  }, [_c('span', {
    staticClass: "ePub-BI"
  }, [_vm._v("1927–1935")])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Shortly after Christmas 1935, Helen Ashbery relayed some astonishing news to her elder son. His short poem about a snow fight that he had composed for fun a few weeks before had been read to acclaim at the New York City apartment of the famous novelist Mary Roberts Rinehart."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-1",
      "id": "notes-ch1_1"
    }
  }, [_vm._v("1")])]), _vm._v(" The crowd of publishers and writers found the work delightfully clever, and they applauded its eight-year-old poet."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-2",
      "id": "notes-ch1_2"
    }
  }, [_vm._v("2")])]), _vm._v(" Hearing the story of his first poem’s journey from his family’s fruit farm in the tiny upstate village of Sodus, New York, all the way to Fifth Avenue, a place he had seen only in movies, John Ashbery felt awakened to new ideas about poetry."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-3",
      "id": "notes-ch1_3"
    }
  }, [_vm._v("3")])]), _vm._v(" He had written the poem to amuse himself; the idea that it might also amuse others, even older artists he had never met or seen, seemed extraordinary. Feeling full of energy and suddenly capable of great things, he tried to write something new, but he could not revive the combination of instinct and concentration that had led to his first poem’s composition. The longer he thought about how he had written “The Battle,” the more utterly mysterious writing poetry suddenly seemed to him, and he gave it up. An unarticulated hope remained within him, though, that words and ideas might one day provide him with an escape from his current existence, which he felt was dull and discouraging.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By any measure, his life in 1935 was ordinary. He was a fourth-grader at the local public school and lived in the family farmhouse with his parents, Helen and Chet Ashbery; his paternal grandmother, Elizabeth; and his four-year-old brother Richard. The only unusual thing that had happened in his life so far was that he had skipped third grade at the recommendation of his second-grade teacher. He had never traveled farther than a one-hundred-mile car trip west to see his father’s relatives in Buffalo. His life was circumscribed by a ten-mile radius between farm, school, and the neighboring village of Pultneyville, where his maternal grandparents, Henry and Adelaide (Addie) Lawrence, lived. He had few school playmates and no close friends; the local kids with whom he most often played were the children of his parents’ friends."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-4",
      "id": "notes-ch1_4"
    }
  }, [_vm._v("4")])]), _vm._v(" During long winters, especially with the excessively cold and snowy local weather, he found little to do at home but read, listen to the radio, draw, or bake with his grandmother on Saturday mornings. He also started to take piano lessons from a local teacher, practicing on the upright in the living room. All day long, his neat and quiet mother cleaned the house or cooked, though she sometimes surprised everyone with pointed remarks at supper. Once, John overheard her refer to his left-handedness—“at least he eats right-handed!”—suggesting, he thought, that she found him slightly odd."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-5",
      "id": "notes-ch1_5"
    }
  }, [_vm._v("5")])]), _vm._v(" He tried to keep out of the way of his father’s temper, and to steer clear of his noisy, athletic, energetic brother. Whenever he could, he stayed with his grandparents in Pultneyville, for he preferred their peaceful house with its rows of books, grand views of Lake Ontario, and doting grandfather.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page8"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "267",
      "src": "images/1SodusFarmhouse_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("The Ashbery farmhouse in Sodus in the 1940s. The Ashbery Farm sign is in front, by the road.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "437",
      "src": "images/2JAatsixweekswith_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John Ashbery at six weeks, with his parents")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "291",
      "src": "images/3DartmouthStHouse_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("The Dartmouth Street house")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page9"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "332",
      "src": "images/41926AddieandHenry_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Addie and Henry Lawrence’s 1926 passport photo, taken in preparation for their first and only trip to Europe and the Middle East")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Since the fall of 1934, when the Lawrences retired to Pultneyville, John had hardly visited Rochester, which was thirty miles away, and had until then provided him with some excitement."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-6",
      "id": "notes-ch1_6"
    }
  }, [_vm._v("6")])]), _vm._v(" He had spent much of his early life in the city, and he missed it. Born at Rochester General Hospital on July 28, 1927, he initially stayed with his mother and her parents, who then lived downtown, at 69 Dartmouth Street, in the middle-class home where Helen and her younger sister, Janet, had grown up. His grandparents encouraged visits, and John’s father was preoccupied in Sodus, for the busiest time of year on the Ashbery Farm occurred during the height of cherry season, in mid-summer. John instinctively enjoyed staying with his grandparents in any case, not only because of their affection, but because he loved their house. Well built in the late 1890s, the modest, Victorian-style house, which smelled of his grandfather’s pipe smoke, had back and front staircases, stained-glass windows, wooden trim, floral wallpaper, built-in bookshelves, and mantels and shelves crowded with knickknacks, including collections of ceramic dogs and miniature shoes. Most were collected from his grandparents’ 1926 trip to Europe and the Middle East, their only trip abroad. Even before he could read, John liked to run his fingers over the textured spines of his grandfather’s collection of leather-bound volumes on the shelves downstairs and imagine their contents."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-7",
      "id": "notes-ch1_7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "437",
      "src": "images/5JAatonewithHenry_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John at about a year old, with his grandfather Henry Lawrence")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "362",
      "src": "images/8ChesterAshberyplan_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Chet Ashbery in 1915, on the Ashbery Farm in Sodus")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "359",
      "src": "images/7grandmotherElizabet_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Mary Elizabeth Koehler (Ashbery), John’s paternal grandmother, known as Elizabeth, in the 1880s, before her marriage. Her parents, Ferdinand Koehler and Elizabeth Thomas (Koehler), emigrated from Germany to Town Line, a suburb of Buffalo, in the 1860s.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "329",
      "src": "images/6grandfatherHenryAs_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Henry Charles Ashbery, John’s paternal grandfather, in his stenciling and rubber stamp business in Buffalo, around 1900. He trained as a stonecutter. Henry, born in Buffalo, was the eldest son of John Aschbery (b. 1835) and Mary Hatfield, both from England, who arrived by boat in 1855.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("From early on, John’s predisposition for his grandparents’ company created tensions with his father, an estrangement that only deepened as he became more vocal about his distaste for the farmhouse and farm life, which were his father’s proudest achievements. The elegant, black-and-white Ashbery Farm sign, which Chet Ashbery made himself and hung by the road in the front of the house, testified to the care and attention he lavished on the house and farm. His own parents, Elizabeth and Henry C. Ashbery, had purchased the seventy-five-acre property in 1914, after twenty-three-year-old Chet discovered the extraordinary land about a mile from Lake Ontario, an area that benefited from the wet and windy weather produced by the lake. He spearheaded the acquisition and convinced his parents and older brother, Wallace, to move from Alden (a suburb of Buffalo), New York, where the family had lived for more than a decade and where they had community roots, to Sodus, where they knew no one."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-8",
      "id": "notes-ch1_8"
    }
  }, [_vm._v("8")])]), _vm._v(" He personally completed most of the renovations on the primitive house and innovations on the orchard, teaching himself woodworking and new agricultural techniques."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-9",
      "id": "notes-ch1_9"
    }
  }, [_vm._v("9")])]), _vm._v(" Over the course of a decade, the Ashbery family became integral to the community, and Chet a sought-after local bachelor."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-10",
      "id": "notes-ch1_10"
    }
  }, [_vm._v("10")])]), _vm._v(" Charismatic, athletic (he played catcher on the local semipro baseball team), and passionate about farming, he married a college-educated city girl on September 5, 1925. Reporting on Chet’s marriage to Helen Lawrence of Rochester, at St. Paul’s Church on East Avenue (the stunningly beautiful location of many high-society city events, including George Eastman’s funeral in 1932), the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Sodus Record")]), _vm._v(" noted warily that “one of the best known young men of Sodus” and “a leading young farmer and fruit grower” had married a woman “not well known here.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-11",
      "id": "notes-ch1_11"
    }
  }, [_vm._v("11")])]), _vm._v(" The community’s guardedness about the city equaled John’s later resistance to the farm. When he ventured out into the orchard, as he sometimes did alone, even as a young child, he explored the landscape, talked to farmhands, and played with family dogs. On one solo walk, he saw a bag filled with crystals that looked like candy. A farmhand encouraged him to taste it. His parents were frightened and furious later, when they realized he had eaten fertilizer, a detail of farm life he later invoked in “Popular Songs” to describe “the guano-lightened summer night landscape,” a phrase that sounds romantic but is not.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "344",
      "src": "images/9-10ChetAshberyWedding_fmt.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Chet and Helen on their wedding day, September 5, 1925")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John’s dislike for the farm was not only a preference for other ways of living, but a reaction to familial stresses that developed not long after he was born. When John was three months old, Chet’s sixty-one-year-old father died of a sudden heart attack in his bedroom. Chet and Helen immediately moved from their own apartment in the village to the farmhouse to live with Chet’s mother. Helen did not know her mother-in-law well, and though sensitive to her grief, she was taken aback by the woman’s imperious, uneducated manner. There was an immediate loss of privacy and more demanding physical responsibilities from living on a farm, and Helen escaped so often to her parents’ house in Rochester that it became something of an Ashbery family joke, though a bitter one for Chet."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-12",
      "id": "notes-ch1_12"
    }
  }, [_vm._v("12")])]), _vm._v(" During the first two years of John’s life, he had few intimate moments with his father."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-13",
      "id": "notes-ch1_13"
    }
  }, [_vm._v("13")])]), _vm._v(" Chet had been extremely close to his father, and the day-to-day work of running the farm by himself (his brother had long since moved back to Buffalo to marry), compounded by the financial stressors of the Depression-era years, wore him down. With financial anxieties mounting, his already short temper became explosive."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-14",
      "id": "notes-ch1_14"
    }
  }, [_vm._v("14")])]), _vm._v(" His father-in-law, whose respected and stable career as a physics professor and chair of the department at the University of Rochester had spanned nearly forty years already, proffered a $4,500 gift so Chet could pay off his parents’ mortgage."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-15",
      "id": "notes-ch1_15"
    }
  }, [_vm._v("15")])]), _vm._v(" This money gave Helen immediate financial independence from her mother-in-law, but it also placed Chet in a new and financially dependent position, which was uncomfortable for him, and he took his frustrations out verbally on Helen."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-16",
      "id": "notes-ch1_16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "291",
      "src": "images/11Johnonfarm_fmt.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John with horses on the farm, about 1930")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "518",
      "src": "images/12JAandChicks_fmt.jpg",
      "width": "300"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John with baby chicks, around 1929")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "228",
      "src": "images/13JAandPal_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John and “Pal,” around 1931")]), _vm._v(" "), _c('p', {
    staticClass: "IMG"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "234",
      "src": "images/141931JAonTricycle_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("John on his tricycle in back of the Dartmouth Street house, around 1931")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John gathered and stored impressions—first, of what he saw and, later, of how he felt. In his earliest memory, a black car zoomed by on the road in front of the farmhouse."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-17",
      "id": "notes-ch1_17"
    }
  }, [_vm._v("17")])]), _vm._v(" Sometime later, he walked through a field of tall grass across from the house on a calm summer evening, and he felt a sensation that he could only later articulate as peacefulness."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-18",
      "id": "notes-ch1_18"
    }
  }, [_vm._v("18")])]), _vm._v(" Shortly after his brother, Richard Seeley Ashbery, was born on March 12, 1931, John watched his parents arrive with the new baby at Dartmouth Street. His mother felt so faint walking up the path to the house that Chet scooped her up and carried her upstairs to bed, and John suddenly experienced a tremendous surge of tenderness toward them both. John followed them to his mother’s room and did “a funny little dance” to try to make her feel better, but she was too exhausted to enjoy it, and his father and grandparents ushered him out."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-19",
      "id": "notes-ch1_19"
    }
  }, [_vm._v("19")])]), _vm._v(" A few weeks later, the family sat together in the front pew at St. John’s Church in Sodus to celebrate Richard’s baptism. The Reverend John Williamson called the family forward, but added, “No, not you, John.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-20",
      "id": "notes-ch1_20"
    }
  }, [_vm._v("20")])]), _vm._v(" Rebuked, he sat down again, embarrassed. One afternoon not long afterward, he was standing next to his father in the barn at the farm when Chet asked him whom he loved more, his mother or father. John thought of his gentle, pretty mother and responded quickly, “Mother, of course,” and immediately felt ashamed because he had spoken the truth and disappointed his father."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-21",
      "id": "notes-ch1_21"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Helen and her two boys continued to stay in Rochester as she recovered her strength, and since John was expected to stay out of the way, he learned to entertain himself. One afternoon, he rummaged through a handsome green rectangular box from the B. Forman Co. department store, which his grandparents had kept to hold memorabilia from their trip abroad, the year before he was born. It was a treasure chest containing postcards, pamphlets, maps, and menus, with tiny reproductions of paintings, sculptures, pyramids, churches, and gardens. For weeks he studied the box’s mysterious contents without being able to read a word, yet the pictures and writing, much of it in foreign languages, fascinated him. When he exhausted that amusement, he left the house by himself without informing anyone and took his tricycle out for a ride around the block, a mild act of transgression that felt thrilling."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-22",
      "id": "notes-ch1_22"
    }
  }, [_vm._v("22")])]), _vm._v(" A neighbor alerted his mother, who went to collect him, but not before his brief adventure gave him a first, delicious taste of independence, an experience he alluded to in several published and unpublished poems: “Take out my tricycle for a spin and return it / before anyone missed me” ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Flow Chart")]), _vm._v(", 1991); “I ride my tricycle of thought / Along their sparkling sidewalks, remarking the uneven places” (“The Children”)."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-23",
      "id": "notes-ch1_23"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Soon it was time to attend school, but the Sodus school system did not have a kindergarten. John’s parents and grandparents decided that, beginning in the fall of 1932, just after John turned five, he would move to the Dartmouth Street house to attend Francis Parker School No. 23. Henry Lawrence made arrangements, and Chet went along with his plan, even though it meant being separated from his elder son for nearly a year. Chet later described his father-in-law as “very interested in John’s education.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-24",
      "id": "notes-ch1_24"
    }
  }, [_vm._v("24")])]), _vm._v(" John felt overjoyed with these plans but sensed enough underlying tensions to keep his feelings to himself. Once the school year began, he walked two blocks every morning to the same highly respected public school on Barrington Street that his mother and Aunt Janet had both attended, and where the bell still rang sonorously from the bell tower at eight each morning. Inside, dark wood paneling, transom windows, and polished oak wood floors made the two-story structure seem much more like a school"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("house")]), _vm._v(" than a public school."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-25",
      "id": "notes-ch1_25"
    }
  }, [_vm._v("25")])]), _vm._v(" John liked his teacher Miss Austin and was excited that many children whom he had met on Dartmouth Street were in his class."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-26",
      "id": "notes-ch1_26"
    }
  }, [_vm._v("26")])]), _vm._v(" His personal goal for the year was to learn how to read.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("On most days after school, he played outside with other children on Dartmouth Street until his grandparents called him home. His favorite imaginative game was to “make up” and “perform plays” with Evelyn Weller and her older sister (who lived in a Victorian mansion at 95 Dartmouth), using the Wellers’ big backyard."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-27",
      "id": "notes-ch1_27"
    }
  }, [_vm._v("27")])]), _vm._v(" Once back home, John was expected to remain quiet and occupied. Even before he could read well, he liked to pore over his grandparents’ enormous set of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Book of Knowledge")]), _vm._v(" volumes, studying colorful drawings and deciphering some of the words in his two favorite sections: “The Child’s Book of Poetry,” which included hundreds of Romantic and Victorian poems, many of which he soon memorized, and “Things to Make and Things to Do,” which described a series of often complex steps for building things and playing games."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-28",
      "id": "notes-ch1_28"
    }
  }, [_vm._v("28")])]), _vm._v(" On some special afternoons, he accompanied his grandfather on errands in his grandparents’ newest Ford. They drove to Wegman’s grocery store on East Avenue, which had just introduced the first “vaporized spray” to keep vegetables moist. As his grandfather shopped, John stood still, waiting for the water to mist the greens, a vision he found “beautiful.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-29",
      "id": "notes-ch1_29"
    }
  }, [_vm._v("29")])]), _vm._v(" Other afternoons, Addie hosted one of several women’s groups, including the Rochester Poetry Society, the Hakkoreoth Reading Club, and an outreach committee for the nearby Memorial Art Gallery. She was neither an enthusiastic nor an accomplished cook, but for these afternoons, she made such delicate and delicious finger sandwiches that John’s mouth watered in anticipation."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-30",
      "id": "notes-ch1_30"
    }
  }, [_vm._v("30")])]), _vm._v(" He would not dare take one until she offered, though, for his grandmother disciplined him so frequently for small infractions at home that he wondered if she disliked him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Addie was strict, and John learned to be polite and careful. Her home was a place primarily to instill manners and morals in children."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-31",
      "id": "notes-ch1_31"
    }
  }, [_vm._v("31")])]), _vm._v(" Once, when John was about three years old, he yelled “Wipe!” from the bathroom upstairs while she was in the backyard hosting a garden party for professors’ wives, and she harshly punished him for it."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-32",
      "id": "notes-ch1_32"
    }
  }, [_vm._v("32")])]), _vm._v(" A book that Addie kept called "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Child at Home; or, The Principles of Filial Duty")]), _vm._v(" (1833) encapsulated her approach to child-rearing. The gentler end of this view toward correcting childhood behavior included social advice at the heart of the proverb “Least said, soonest mended,” the phrase that Ashbery shortened in the late 1960s as the title for a poem that chronicled the “early lessons” of growing up."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-33",
      "id": "notes-ch1_33"
    }
  }, [_vm._v("33")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John absorbed a feeling and a mood while living with his grandparents that he connected to their nineteenth-century American values and beliefs. Henry Lawrence was born in 1864 at the Sodus Hotel, which his entrepreneurial parents briefly owned during its heyday."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-34",
      "id": "notes-ch1_34"
    }
  }, [_vm._v("34")])]), _vm._v(" The sudden death of his young father less than two years later, however, changed Henry’s fortune."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-35",
      "id": "notes-ch1_35"
    }
  }, [_vm._v("35")])]), _vm._v(" By sheer force of his intelligence, discipline, and thriftiness, he finished his PhD by the age of thirty after doing research in the new field of X-ray technology (then called Roentgen rays) at both the University of Rochester and Cornell. Though he chose to study science, he was equally adept in languages and business, earning extra money tutoring students in Greek and Latin and, later, in buying and selling stocks. ")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John’s grandmother Addie, three years younger than her husband, grew up on a family farm just outside Pultneyville and trained to be a schoolteacher (though she never worked), excelling in multiple subjects and performing in plays before marrying."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-36",
      "id": "notes-ch1_36"
    }
  }, [_vm._v("36")])]), _vm._v(" They were both products of the American Victorian age, a period marked by “the rise of capitalism” and the dominance of “the individual,” which Ashbery describes in the opening of “Definition of Blue” ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Double Dream of Spring")]), _vm._v(", 1970). His grandparents’ lives and attitudes profoundly shaped this “definition.” They took pride in their new home, in their downtown neighborhood of professional men, in their smart investments, their new car, their family, their church, and their nation. They believed in public school, shoveling one’s own driveway in the snow (which Henry Lawrence was still doing at ninety when he passed away), and Republican presidents. They were against the New Deal and “that man,” President Franklin D. Roosevelt."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-37",
      "id": "notes-ch1_37"
    }
  }, [_vm._v("37")])]), _vm._v(" Optimistic and modest, they lived and spoke with a clarity—on behavior, morality, and individual responsibility—that appealed to John.")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page18"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "299",
      "src": "images/15-16greatgrandfatherE_fmt.jpg",
      "width": "500"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Edmund Wilson Lawrence and Ruth Ann Holling Lawrence Owen, Henry Lawrence’s parents. Edmund Lawrence died of “congestion of the stomach” a few months after Henry was born. She remarried an Englishman, Samuel Owen, “a renowned Glass Blower,” who opened “Owen’s Crystal Museum” on Jay Street in Pultneyville. Samuel’s adult daughter married Ruth Ann’s brother, Captain James Holling, in 1868, and the local Commercial Press gleefully reported on the resulting complex family relationships.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Attentive to the exactitude with which they spoke (and lived), John became very alert to new sounds and meanings of words as he was learning to read. In the evenings before bed, his grandfather read stories aloud. He began with fairy tales, then read "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Heroes")]), _vm._v(", Charles Kingsley’s popular children’s adaptation of Greek myths, which John loved, and later Johanna Spyri’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Heidi")]), _vm._v(". His grandmother also introduced him to new words. She used the term "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("vestibule")]), _vm._v(" to refer to the tiny tiled room between her two heavy wooden front doors, where the mail landed with a satisfying thud each day after it passed through the brass mail slot, a word that John enjoyed repeating. During kindergarten that fall, he had his own unexpected encounter with a word: “I sat alone at school on the second-floor landing looking down … and thought, "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("I regret these stairs")]), _vm._v(".” He had no idea why the phrase came into his mind, for it was unlike anything anyone had said to him, but he liked it. He understood how "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("regret")]), _vm._v(" was usually used, but the oddness of the phrase suddenly expressed the precise shape of his melancholy mood sitting on the steps in the afternoon light."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-38",
      "id": "notes-ch1_38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("John often stayed with his grandparents on weekends, even when he could have returned to the farmhouse. One spring weekend in 1933, his grandmother took him downtown to see his first movies, an excursion that felt very grown-up. They saw the animated short film "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Three Little Pigs")]), _vm._v(", followed by Frank Buck’s live-action "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Bring ’Em Back Alive")]), _vm._v(". The following winter they also went together to see the new live-action version of "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Alice in Wonderland")]), _vm._v(", featuring Gary Cooper. By then, though, he had moved back to the Sodus farm and was missing his life in the Dartmouth Street house."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-39",
      "id": "notes-ch1_39"
    }
  }, [_vm._v("39")])]), _vm._v(" In the prose poem “The Lonedale Operator” ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Wave")]), _vm._v(", 1984), Ashbery compresses his memories of these separate outings into a reflection on first experiences and the confusion one feels as one’s tastes change. He sees "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Alice in Wonderland")]), _vm._v(" as an adult and wonders how he could have ever liked the film as a child:")]), _vm._v(" "), _c('p', {
    staticClass: "EXT"
  }, [_vm._v("Years later I saw it when I was grown up and thought it was awful. How could I have been wrong the first time? I knew it wasn’t inexperience, because somehow I was experienced the first time I saw a movie. It was as though my taste had changed, though I had not, and I still can’t help feeling that I was right the first time, when I was still relatively unencumbered by my experience.")]), _vm._v(" "), _c('p', {
    staticClass: "STNI"
  }, [_vm._v("He feels upset, even becoming terrified at his new thoughts, because he clearly remembers his first few experiences at the movies and his delighted reactions to what he saw. He asks, rather incredulously, “How could I have been wrong the first time?” He has trusted his first impressions, which he must concede are incorrect in this case. He concludes, however, that his initial judgments have value to him as “unencumbered” responses to art. These memorable first impressions provide a foundation from which he can test his future feelings and opinions.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John contrived to stay with his grandparents even after kindergarten ended, traveling with them to their summer home in the tiny village of Pultneyville, on the shore of Lake Ontario. He was forestalling the inevitable return to the farmhouse, which was going to happen by the end of the summer. He had been happier in Rochester than in Sodus, but he was even happier in Pultneyville. The view of the lake from his grandparents’ living room window was so marvelously beautiful in the summer that he felt a joyful sensation of having “what I wanted.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-40",
      "id": "notes-ch1_40"
    }
  }, [_vm._v("40")])]), _vm._v(" Adding to this ecstatic feeling was a new friendship. One day, he discovered six-year-old Mary Wellington collecting shells on the beach across from his grandparents’ house. Her grandmother had recently purchased a summer home a few doors down from the Lawrences’. Mary was an ethereal, fine-boned, graceful creature with light blond hair and blue eyes. She did not look at all like the irreverent tomboy she actually was, and John was smitten."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-41",
      "id": "notes-ch1_41"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page20"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "289",
      "src": "images/17PultneyvilleHouse_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("The side porch of the Pultneyville house, which looks out onto Lake Ontario, early 1930s")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page21"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "334",
      "src": "images/18MaryWellingtonAge_fmt.jpg",
      "width": "400"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Mary Wellington in Pultneyville, age five, just before John remembers meeting her. She lived in Rochester and stayed, along with her two “very pretty” older sisters, at her grandmother’s house for the summer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They sought each other first thing in the morning and, for several summers, were inseparable during the day. Together they combed the beach for treasures, made up new stories, climbed trees, and sprinted from one backyard to another. John’s favorite summer uniform was either a bathing suit or a one-piece romper with green shorts that buttoned into a polka-dotted top and felt like no clothes at all; Mary wore light summer dresses, which John worried were transparent."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-42",
      "id": "notes-ch1_42"
    }
  }, [_vm._v("42")])]), _vm._v(" They designated an area full of willow trees behind Pig Lane as their official hideout. On hot days, they sat on the Wellington dock with their feet dangling in the lake. When they felt hungry, they bought five cents’ worth of candy at Fred Hart’s store or ate Fig Newtons at the Lawrences’. On rainy days, they played cards on the enormous couch in the Wellington living room. At night, John lay contented in the twin bed in his second-floor bedroom, with the window open, smelling the lake and listening to the hum of wind and water. Later Ashbery described how deeply he absorbed the sounds of this melancholy water music: “the plaintive sound / of the harp of the waves is always there as a backdrop / to conversation and conversion, even when / most forgotten.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-43",
      "id": "notes-ch1_43"
    }
  }, [_vm._v("43")])]), _vm._v(" John’s initial associations with waves were connected to his new friendship and the stunning location, more pleasurable than “plaintive,” except in worrying about his move back home.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("For a sixth-generation Pultneyvillian, John carried his legacy lightly. There was almost no area of the tiny village he explored on which his ancestors had not planted roots, in the form of a house, memorial, or tombstone. Some relatives, such as his grandfather’s cousins Paul (1872–1957) and Lillian (1864–1953) Holling, unmarried siblings who stayed across the street, retained distinct Victorian sensibilities, styles of dress, and mannerisms, and seemed like living relics. Nearly every villager displayed ancestral objects of some historical interest in their homes, a practice that led to an annual show-and-tell in the town hall on May 15, the anniversary of the Battle of Pultneyville (1814) during the War of 1812, when British gunboats fired cannons briefly at the shore, a minor historical footnote confirmed when Henry Lawrence and several other neighbors dug up cannonballs in their yards. John’s grandfather kept other historical artifacts, including a “green wooden slab” that had been a ship’s cabin door his great-uncle Horatio Throop allegedly used to swim five miles to safety when his boat sank in 1820."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-44",
      "id": "notes-ch1_44"
    }
  }, [_vm._v("44")])]), _vm._v(" John could trace his lineage, issuing from a long line of sailors, through objects dating back to the late 1700s.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John learned most about his past by rummaging around the Lawrences’ frame house, which sheltered the detritus of more than one hundred years of local work and family life. His great-great-uncle Washington Throop built it in the early 1830s to provide his daughter, Sarah, with a clear sight of ships arriving and departing the busy port, a view of the lake John also appreciated. (Herman Melville described Lake Ontario befittingly as one of “those grand fresh-water seas of ours,” which “possess an ocean-like expansiveness, with many of the ocean’s noblest traits.”)"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-45",
      "id": "notes-ch1_45"
    }
  }, [_vm._v("45")])]), _vm._v(" Sarah gave the house to Henry and Addie Lawrence in 1916, along with remnants of her family’s sailing life. Her scrapbook chronicled the family’s successful nineteenth-century steamship business, and her diary illuminated her daily view of Lake Ontario out the living room window during her final bleak and lonely winter."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-46",
      "id": "notes-ch1_46"
    }
  }, [_vm._v("46")])]), _vm._v(" Both scrapbook and diary became cherished objects in the Lawrence household, and a source of curiosity and entertainment for John. Years later, when Ashbery dramatized and memorialized Sarah’s romantic view of the water—“So many brave skippers / such a long time at sea,” in “Cousin Sarah’s Knitting” ("), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Wakefulness")]), _vm._v(", 1998)—he channeled that combination of history and melodrama he encountered first through seeing her scrapbooks and diaries lying on bookshelves. Ashbery captures his curious and whimsical attitude toward the past in “Fragment”: “Thus reasoned the ancestor, and everything / Happened as he had foretold, but in a funny kind of way.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-47",
      "id": "notes-ch1_47"
    }
  }, [_vm._v("47")])]), _vm._v(" Surrounded by venerated objects and ancestors, John Lawrence Ashbery was also in a “kind of way” the future that their myths, histories, and prophecies “had foretold,” an idea that struck him as “funny.”")]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page23"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "363",
      "src": "images/19CousinSarahSara_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Sarah LaPlata Throop Miller (1838–1915) left her Pultneyville house on Washington Street, overlooking Lake Ontario, to Henry Lawrence. Sarah’s father, Washington Throop, built the house in the early 1830s, next door to his brother Horatio Throop’s house. Sarah died in the living room in May 1916, leaving a diary of the final six months of her life, which John Ashbery found and read as a child. His poem “Cousin Sarah’s Knitting” alludes to details of her life.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John dreaded the end of the summer and the move back to the farm. He felt isolated, restless, and unhappy there, and he was much more aware of his feelings by virtue of the comparison with his more peaceful and interesting life the previous year in Rochester. The smell of his father’s Chesterfield cigarettes pervaded the house, much less appealing to John than the aroma from his grandfather’s pipe."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-48",
      "id": "notes-ch1_48"
    }
  }, [_vm._v("48")])]), _vm._v(" He had not seen his father on a daily basis for over a year, and the awkwardness between them intensified into regular conflicts. It seemed as though Chet spanked John for even the tiniest misdeeds, and scolded him more often and more harshly than Addie ever had. At the farm, “Richard ran everywhere and got into everything,” and John “started to think of him as a pest.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-49",
      "id": "notes-ch1_49"
    }
  }, [_vm._v("49")])]), _vm._v(" In John’s absence, Richard and Chet had bonded. Their exuberant, outdoorsy, athletic personalities were very similar."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-50",
      "id": "notes-ch1_50"
    }
  }, [_vm._v("50")])]), _vm._v(" John felt like an outsider and unconsciously retaliated by actively seeking out quarrels. He complained about the foul-smelling chickens, which ran around right outside the kitchen. One afternoon, he let the water pump run and then rolled around in the mud pile he had created. Another day, he turned a hose on one of his father’s uncles who had been unfriendly, soaking him. These infractions resulted in a “walloping,” lightly by his mother and much more severely by Chet."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-51",
      "id": "notes-ch1_51"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "IMG",
    attrs: {
      "id": "page24"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "height": "310",
      "src": "images/201933RAPortrait_fmt.jpg",
      "width": "250"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "FIG"
  }, [_vm._v("Richard, about 1933")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John felt solitary and unhappy. His parents and grandmother were busy trying to make ends meet on the farm, and there were very few objects or books around the house for him to explore. When he looked out the front or the back of the Ashbery farmhouse, he saw vast swaths of land and no other houses, a stark and lonely view. In the winter, for months on end, the land was covered in deep snow. In the late spring, nearby Lake Ontario intensified weather patterns so that it was often very blustery and wet, though John began to like that kind of unsettled sky most of all, for it fit his unhappy mood. The farmhouse was also literally a colder place to live than the Dartmouth Street house had been. It had lower ceilings and less natural light, and its furnace blew heat directly into the living room, which was so far from John’s bedroom in the upstairs back corner that the warm air could not reach it."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-52",
      "id": "notes-ch1_52"
    }
  }, [_vm._v("52")])]), _vm._v(" On Saturday mornings, John warmed up in the kitchen while his paternal grandmother baked küchen and bread, recipes she knew by heart from her German-born parents."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-53",
      "id": "notes-ch1_53"
    }
  }, [_vm._v("53")])]), _vm._v(" She would affectionately scold John and “grab and wash his ears.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-54",
      "id": "notes-ch1_54"
    }
  }, [_vm._v("54")])]), _vm._v(" He enjoyed these mornings most of all, but he missed his home with his other grandparents.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He felt no more comfortable at school. Despite the advantage of his year in kindergarten and the benefit of knowing already how to read and write, he received his lowest grades during all of primary school at the beginning of first grade in Sodus; a B in reading, C in writing, and B+ in drawing."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-55",
      "id": "notes-ch1_55"
    }
  }, [_vm._v("55")])]), _vm._v(" His poor grades were especially disappointing because he naturally gravitated toward reading, writing, and drawing. Still, the marks did not bother him as deeply as his lack of friends. He did not have much in common with his Sodus classmates, whose interests generally leaned toward hunting, sports, and farming."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-56",
      "id": "notes-ch1_56"
    }
  }, [_vm._v("56")])]), _vm._v(" In the afternoons and weekends, the primary social events took place at high school basketball games, community pastimes in which John had neither talent nor concern. He quickly gained a reputation for being “smart, quiet, and different,” and even schoolmates who were the children of family friends were not especially nice to him."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-57",
      "id": "notes-ch1_57"
    }
  }, [_vm._v("57")])]), _vm._v(" Chet arranged for his friends Art and Castelle Boller to drive John to school with their daughters on some mornings. Mary Ann, who was also Chet and Helen’s goddaughter, liked to bet her sister that John would trip as he walked from his door to their car."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-58",
      "id": "notes-ch1_58"
    }
  }, [_vm._v("58")])]), _vm._v(" Some classmates were even more direct about their dislike, calling him “a sissy.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-59",
      "id": "notes-ch1_59"
    }
  }, [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The quickest way to escape in Sodus was through movies, and John enthusiastically went to see any film with anyone. Any theater would do, but the grandest ones, which he liked best, were in the bigger cities of Newark and Rochester. He went with his Ashbery grandmother to see "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Flirtation Walk")]), _vm._v(" (1934) because her nephew Dutch Koehler, then a West Point cadet, had a cameo in it. She yelled “There he is!” at the screen, to John’s amusement. He went with his parents to see the new Busby Berkeley films at the grand theater in Newark, including "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Dames")]), _vm._v(" (1934) and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Gold Diggers of 1935")]), _vm._v(", for musicals were his father’s favorite, and John, too, became a fan. He went with them to see the movies of the Ritz Brothers, a slightly “more evil version of the Marx Brothers,” who had several popular films during the mid-thirties."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-60",
      "id": "notes-ch1_60"
    }
  }, [_vm._v("60")])]), _vm._v(" While watching the trailer for an upcoming film "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Night Is Young")]), _vm._v(" (1935), John heard the song “When I Grow Too Old to Dream,” which he felt was “too wonderful” and immediately afterward bought the sheet music and learned to play the song on the piano."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-61",
      "id": "notes-ch1_61"
    }
  }, [_vm._v("61")])]), _vm._v(" Even scary films were worth seeing because they were entertaining, although when his mother took him to see an adaptation of Charles Dickens’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Old Curiosity Shop")]), _vm._v(" (1934), the tense scenes with Quilp terrified him so much that she had to take him out of the theater."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-62",
      "id": "notes-ch1_62"
    }
  }, [_vm._v("62")])]), _vm._v(" He saw movies without his parents, too, beginning with Laurel and Hardy’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Babes in Toyland")]), _vm._v(" (1934), a comedy with a very dark sense of humor that his friend Buddy Gaylord unwittingly chose for his seventh birthday party outing."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-63",
      "id": "notes-ch1_63"
    }
  }, [_vm._v("63")])]), _vm._v(" John found the film’s “very funny” rapid-fire dialogue, which included puns, double entendres, and other “verbal pyrotechnics,” “exciting.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-64",
      "id": "notes-ch1_64"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("The more John saw and heard, the more he sought ways to get others to hear and see him. During the winter, his parents invited Miss Chadwick, his second-grade teacher, over for dinner one evening. There had recently been a very popular song that played on the radio called “Throw Another Log on the Fire.” Toward the end of the meal, as the fire in the fireplace was dimming, John said, “So shall I throw another log on the fire?” Everyone laughed uproariously, which he loved."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-65",
      "id": "notes-ch1_65"
    }
  }, [_vm._v("65")])]), _vm._v(" At school, he often made witty remarks, but he also tried to stand out in other ways. Although the youngest student in the fourth grade, he volunteered to perform Alfred Lord Tennyson’s “The Eagle” in the auditorium at an assembly for the entire school. He had discovered the poem while perusing a children’s poetry textbook at school and liked how “short and dramatic” it was. The description of the eagle enjoying its high perch and its ability to fall “like a thunderbolt,” allusions to Zeus that John knew from reading about Greek mythology in Kingsley’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Heroes")]), _vm._v(", also appealed to him."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-66",
      "id": "notes-ch1_66"
    }
  }, [_vm._v("66")])]), _vm._v(" It took him only a few minutes to memorize the poem, and he recited both stanzas perfectly:")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("He clasps the crag with crooked hands;")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("Close to the sun in lonely lands,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("Ring’d with the azure world, he stands.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("The wrinkled sea beneath him crawls;")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("He watches from his mountain walls,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("And like a thunderbolt he falls.")]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("No parents or grandparents were invited to (or even knew about) the recitation. John’s performance was for classmates, teachers, and him only."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-67",
      "id": "notes-ch1_67"
    }
  }, [_vm._v("67")])]), _vm._v(" His voluntary decision to take on the challenge of performing poetry suggested a willingness, even a desire, to behave in ways utterly independent from others in his school and town. No one around him explicitly connected the image from the poem of the lonely bird soaring above and looking down at a world “beneath him” with the voice of the eight-year-old boy speaking those words, but his classmates intuitively sensed his ambition and lack of interest in them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His grandfather also recognized John’s desire for escape and encouraged his sense of independence. His grandparents had been away for several weeks on a series of car trips, to visit John’s aunt Janet and her husband, Tom Taft, and John was eager to have them home. Henry had written him an official-looking letter from Ohio, on “Mansfield-Leland Hotel” stationery, promising a visit to Pultneyville soon: “When we come home I will come down and get you to spend Saturday and Sunday.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-68",
      "id": "notes-ch1_68"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They picked him up as promised, to see a movie in Rochester."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-69",
      "id": "notes-ch1_69"
    }
  }, [_vm._v("69")])]), _vm._v(" Planning to watch the new adaptation of Shakespeare’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Midsummer Night’s Dream")]), _vm._v(" (1935), starring Mickey Rooney as the mischievous forest spirit Puck and Olivia de Havilland as Hermia, John read his grandparents’ copy of Charles and Mary Lamb’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Tales from Shakespeare")]), _vm._v(" (1807) and his grandfather’s 1864 edition of the "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Comedies")]), _vm._v(", though he made little headway at first."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-70",
      "id": "notes-ch1_70"
    }
  }, [_vm._v("70")])]), _vm._v(" The film opened with a performance of Mendelssohn’s entire "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("A Midsummer Night’s Dream")]), _vm._v(" Overture, a piece that John had never heard before. Directed by Max Reinhardt and William Dieterle, the film received mixed reviews, but to John, who discovered both Shakespeare and Mendelssohn in the same afternoon, the combination of words, ideas, humor, and music was unequaled by any previous experience of art."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-71",
      "id": "notes-ch1_71"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("When they arrived home in Pultneyville the evening of the movie, John went directly upstairs to his grandparents’ bedroom, sat at his grandfather’s desk with its even then old-fashioned Remington typewriter and composed his first poem."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-72",
      "id": "notes-ch1_72"
    }
  }, [_vm._v("72")])]), _vm._v(" He titled it “The Battle”:")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("The trees are bent with their glittering load,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("The bushes are covered and so is the road.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("The fairies are riding upon their snowflakes,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("And the tall haystacks are great sugar mounds.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("These are the fairies camping grounds.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("Their swords are made from glittering ice,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("They sparkle and shine and look very nice.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("But Mother Earth’s soldiers—they’re bushes and trees,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("Then there are some rabbits who would venture out.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("But that all depends on what they’re about.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("The battle’s beginning! It’s a fight to the end.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("The rabbits pitch in! Some help they must lend.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("The bushes are conquered! Well that was short.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("How shall they celebrate their victory?")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("Well, my dears, that’s a long story.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("They celebrated their victory with a feast,")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("With turkey and dressing and cakes of yeast.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("But let us get back to the trees and the bushes.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("They are weighted down with snow that pushes and pushes.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("But who should come along then little boy Ned?")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("With muffler of blue and mittens of red.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("He freed them from their tiresome load")]), _vm._v(" "), _c('p', {
    staticClass: "EXTVL"
  }, [_vm._v("And then was off again down the road.")]), _vm._v(" "), _c('p', {
    staticClass: "SEXTV"
  }, [_vm._v("BUT—when the fairies came out again they were angry, every one!")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("But burst out in laughter at having such fun.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("They vowed they would never again have a battle")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("That was so much ado about nothing."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-73",
      "id": "notes-ch1_73"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("John’s story of a fight between fairies and bushes was humorous and clever, but even more amusing was his invention of the whimsical, wry narrator (a Puck-like character, though one slyer and less devious) who, in a series of highly comical asides, describes the escalation of anger, the battle itself, and its aftermath. For two stanzas, tensions between Mother Earth and fairies build until an eruption at the beginning of the skillfully written third stanza. The narrator expresses his excitement: “The battle’s beginning! It’s a fight to the end.” Given the announcement, one expects an epic struggle to follow, but the poem compresses the action, and a mere two lines later, the fairies triumph and the narrator returns to comment wryly on this remarkably speedy coup: “The bushes are conquered! Well that was short.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If that were all, the poem would have been clever enough, but there was more. Battle over, the narrator addresses his curious audience and becomes gently coy: “How shall they celebrate their victory? / Well, my dears, that’s a long story.” Adopting this cozy, old-fashioned tone, the savvy narrator with a sense of his audience’s limited tolerance for dull details appears to launch into the “long story” of the celebration, a “feast, / With … cakes of yeast,” but interrupts himself to “get back to the trees and the bushes,” the main action. Again the description of this battle is compressed and quick. Anger escalates, until they “burst out in laughter at having such fun” over “so much ado about nothing,” the narrator’s witty allusion to another Shakespeare play. From beginning to end, the narrator maintains a tone of distant, lighthearted mastery over the story, a complex good humor that is the poem’s most impressive and sophisticated feature.")]), _vm._v(" "), _c('p', {
    staticClass: "TXS"
  }, [_vm._v("Up until the evening he typed out his poem, John had amused only himself with his active imagination. The urge to write, however, was something extraordinary and new. Inspired by his excitement about Shakespeare’s play and Mendelssohn’s music, he expressed his feelings in his own style, transforming the season from the play’s enchanted summer to a Rochester winter and replacing the marriage drama with a snow fight. Although written for fun, John’s first poem demonstrates a prodigious talent. There had been few signs up until this point that he could write such a poem (or any poem). Yet his deft, instinctive delight in the film had built upon a foundation of knowledge about poetry that he had gained in such ordinary ways that he hardly knew he had it. Some of what he knew was merely obtained from observing his grandfather, who often picked up a favorite volume of Percy Bysshe Shelley’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Minor Poems")]), _vm._v(", or "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Selections from the")]), _vm._v(" "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Poetical Works of Robert Browning")]), _vm._v(", or Cowper’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Task")]), _vm._v("; or from his grandmother, who cut Edgar Guest poems out of newspapers. Henry and Addie also wrote poetry, usually to communicate something amusing or special to each other or their friends. Ten years before he wed her, seventeen-year-old Henry turned a sentence into two neatly composed lines of verse for Addie in her high school autograph book:")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("Drop one pearl in the")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV"
  }, [_vm._v("Casket of memory for me.")]), _vm._v(" "), _c('p', {
    staticClass: "EXTV3"
  }, [_c('span', {
    staticClass: "V3"
  }), _vm._v("Henry E. Lawrence P’ville February 23, 1882"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-74",
      "id": "notes-ch1_74"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "STX"
  }, [_vm._v("For her garden parties, Addie sometimes wrote out place cards that rhymed a person’s name with a witty compliment about his or her personality."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-75",
      "id": "notes-ch1_75"
    }
  }, [_vm._v("75")])]), _vm._v(" John spent so much time reading poems from "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Book of Knowledge")]), _vm._v(" that when his grandparents moved permanently to Pultneyville, in September 1934, they gave him their complete set to keep with him at the farmhouse, where he had few other books of his own. Those volumes included many ballads, stories in verse, and other short, rhymed witty or sentimental poems. John knew well William Allingham’s “The Fairies” (“Up the airy mountain / Down the rushy glen / We daren’t go a-hunting / For fear of little men”…), which helped to inspire his first poem.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The Battle” drew from this natural exposure to poetry, but in its exuberance demonstrated an inclination to write independently from any tradition he had so far encountered. John had no formal training, but he did have an intuitive sense of rhyme, rhythm, and irony, and no inhibitions about relying on or breaking rules. Stanza lengths, metrical and rhyme patterns, and narrative perspectives shift throughout. The final line, a pun on Shakespeare’s "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Much Ado About Nothing")]), _vm._v(", is one of the only perfectly pentameter lines (a combination of iambic and trochaic beats), a meter of which he certainly had never learned, though he had heard it spoken in Shakespeare’s play. He demonstrated, above all else, a quick and naturally musical ear.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In playfully composing the poem, John also documented his earliest ideas about art, thoughts he would deepen and rediscover in the future. In “The Battle,” the fairies’ short-term memory is one of their most charming features; it means that they cannot remain angry for long, and it allows the poem to shift from one emotion to another very quickly. This technique was John’s adaptation of one of the most moving aspects of Shakespeare’s play, the sense that anything can happen in a dream and the uncertainty one feels, at times, not knowing whether what one remembers happened in a dream. When the young characters awaken in the forest in act 4, having recovered their personalities and natural desires, they deliver the play’s most memorable and moving poetry through their collective confusion about what they dimly remember of their other desires. Demetrius describes his dreamlike memory of the eventful night as “small and undistinguishable, / Like far-off mountains turned into clouds.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-76",
      "id": "notes-ch1_76"
    }
  }, [_vm._v("76")])]), _vm._v(" The young characters’ confusion between dream and memory allows them remarkable freedom to forget their painful romantic longings quickly and move on to adapt to happier feelings and ideas. Almost every character in the play discovers that to dream and to forget are equally crucial ways to learn, an idea that would become a hallmark in many of Ashbery’s mature poems.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("John wrote the poem for himself only, so the swift and positive reaction from members of his family to his tiny tour de force took him completely by surprise. His father laughed. His grandparents praised it. His mother, who never bragged to others about her son and who had no interest in poetry, copied the poem into her own handwriting several times to preserve copies, and shared it with her sister. His aunt Janet was so proud of her nephew that she showed the poem to her cousin Elizabeth Sherwood Rinehart, who in turn gave it to her mother-in-law, Mary Roberts Rinehart. After John was informed of his poem’s journey to New York City and told that it had received great acclaim, he felt inspired to write more. He planned an entire volume of poems and drew a cover page in crayon entitled "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Poems for Boys and Girls")]), _vm._v(". He placed typed drafts of “The Battle” between the covers, but he could not write a new poem."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-77",
      "id": "notes-ch1_77"
    }
  }, [_vm._v("77")])]), _vm._v(" He tried to fall back into that focused, clear state of mind in which he had composed his first poem, but he could not figure out how to make it happen again. The process of writing a poem felt as mysterious to him as if he had never done it, and the more he tried and failed, the more frustrated he grew. He thought about his poem’s success in New York City and could not imagine anything better: “I didn’t think I’d ever be able to pull off another coup like that one. There seemed to be nowhere to go but down.”"), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-78",
      "id": "notes-ch1_78"
    }
  }, [_vm._v("78")])]), _vm._v(" Since he understood that he was never going to be able to write another poem as fine as “The Battle,” he decided to quit writing poetry altogether. Feeling disappointed, but relieved to be rid of the pressure to write, he abandoned his new volume and eventually forgot he had begun it.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Only Addie noticed that John stopped writing poetry after “The Battle.” She encouraged him to coauthor a brief poem on the subject of spring flowers in early 1936. The resulting five couplets, however, beginning “Yellow daffodils, bright and gay / Greet with joy the new born day,” sounded much more like her voice and her taste in poetry than his."), _c('span', {
    staticClass: "en-ref"
  }, [_c('a', {
    attrs: {
      "epub:type": "noteref",
      "href": "#/xhtml/notesch1#notes-ch1-79",
      "id": "notes-ch1_79"
    }
  }, [_vm._v("79")])]), _vm._v(" Working on the composition with his grandmother did not inspire John to want to write any new verse on his own. It would take another seven years before he sat down again to write a new poem.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-229e5985","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 87
// module chunks = 0